// extracted by mini-css-extract-plugin
module.exports = {"collectionTable":"styles_collectionTable__yWvEq","tileContainer":"styles_tileContainer__1gA7P"};